// extracted by mini-css-extract-plugin
export var seeAll = "_ms-0";